/** Row counts offered by every paginated table. */
export const TABLE_PAGE_SIZES = [10, 25, 50, 100] as const;

export const TABLE_DEFAULT_PAGE_SIZE = 10;

/**
 * Floor for a data table's own width. `w-full` alone lets the columns absorb a
 * narrowing window — cells wrap and the row stops being readable — because the
 * table never exceeds its scroll container and so never scrolls. Written as a
 * class rather than a number so Tailwind sees it in the source scan.
 */
export const TABLE_MIN_WIDTH = 'min-w-[46rem]';
